// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/system';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  // loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  // registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: (token: string) => path(ROOTS_AUTH, `/new-password/${token}`),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  sessionInactive: '/session-inactive',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  cases: {
    list: path(ROOTS_DASHBOARD, '/cases/list'),
    excluded: path(ROOTS_DASHBOARD, '/cases/excluded'),
    archived: path(ROOTS_DASHBOARD, '/cases/archived'),
    upload: path(ROOTS_DASHBOARD, '/cases/upload'),
    pacs: path(ROOTS_DASHBOARD, '/cases/pacs'),
    runTasks: (ids: string[], multiInput: boolean) => path(ROOTS_DASHBOARD, `/cases/run-tasks/${ids.join(",")}/multi-input/${multiInput}`),
    dicomViewer: (id: string) => path(ROOTS_DASHBOARD, `/cases/viewer/${id}`),
    resultsViewer: (id: string) => path(ROOTS_DASHBOARD, `/results/${id}`),
  },
  tasks: {
    list: path(ROOTS_DASHBOARD, '/tasks/list')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
  },
  minomx: {
    list: path(ROOTS_DASHBOARD, '/minomx/list'),
    details: (userId: string) => path(ROOTS_DASHBOARD, `/minomx/details/${userId}`),
  },
  admin: {
    auditLog: path(ROOTS_DASHBOARD, '/audit-log'),
    users: {
      new: path(ROOTS_DASHBOARD, '/users/new'),
      list: path(ROOTS_DASHBOARD, '/users/list'),
      edit: (name: string) => path(ROOTS_DASHBOARD, `/users/${name}/edit`),
    }
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
